import React from 'react';
import { string, func } from 'prop-types';
import { Box, Icon, Button, Text } from '@goodrx/matisse';

const EmptyState = ({ button, title, description, icon, onClick }: any) => (
  <Box textAlign="center">
    {icon && <Icon name={icon} size={64} />}

    <Box mt={4} />
    {!!title && (
      <Text as="h4" m="0 0 8px" fontSize={18}>
        {title}
      </Text>
    )}
    {!!description && (
      <Text as="p" m="0 0 16px">
        {description}
      </Text>
    )}
    {!!button && <Button onClick={onClick}>{button}</Button>}
  </Box>
);

EmptyState.propTypes = {
  icon: string,
  title: string,
  description: string.isRequired,
  button: string,
  onClick: func,
};

export default EmptyState;
